import {axiosInstance} from './axiosInstance';

export const setExecutorWebAccessToken = (token: string) => {
	if (token) {
		axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
	} else {
		delete axiosInstance.defaults.headers.common.Authorization;
	}
};
